import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Heading } from '../EditCustomer/Heading';
import { ACCOUNT_REVIEW_COLUMNS, LOCAL_STORAGE, QUERY_KEYS, ROLES } from '../../../constants';
import { getAllAccountReviewsAPI } from '../../../utils/apiServices/accountReviewAPI';
import { getLocalStorageItem, popup } from '../../../utils';
import { Table } from '../../shared';
import { usePagination } from '../../../hooks';
import CreateAccountReviewModal from './CreateAccountReviewModal';
import { useQuery } from '@tanstack/react-query';

const AccountReview = () => {
    const { state } = useLocation();
    const role = useSelector((s) => s.user.role);
    const accountId =
        role === ROLES.USER ? getLocalStorageItem(LOCAL_STORAGE.CUSTOMER_ID) : state?.account_id;
    const accountName = useSelector((s) => s.accountArray?.selectedAccountName) || state?.name;
    const [showModal, setShowModal] = useState(false);
    const [response, setResponse] = useState({ data: [], count: 0 });
    const pagination = usePagination(response.data.length, response.count);

    const { data, isFetching, isFetched, isError, error } = useQuery({
        queryKey: [QUERY_KEYS.ACCOUNT_REVIEWS, accountId],
        queryFn: async () => await getAllAccountReviewsAPI({ accountId }),
        select: (data) => ({ data: data.data, count: data.count }),
        enabled: !!accountId,
    });
    if (isError) popup('error', error?.message);

    useEffect(() => {
        if (data && isFetched) {
            setResponse(data);
        }
    }, [data, isFetched]);

    return (
        <div className='d-flex flex-column gap-3' key={accountId}>
            <Heading
                accountName={accountName}
                heading={`Account Review`}
                showAddButton={role !== ROLES.USER}
                addButtonText={'Create Account Review'}
                handleAddClick={() => setShowModal(true)}
            />
            <Table
                columns={ACCOUNT_REVIEW_COLUMNS}
                data={response.data}
                pagination={pagination}
                pageName={'Account Reviews'}
                stickyColumns={['Title']}
                isLoading={isFetching}
            />
            {showModal && (
                <CreateAccountReviewModal
                    showModal={showModal}
                    setShowModal={setShowModal}
                    accountId={state?.account_id}
                />
            )}
        </div>
    );
};

export default AccountReview;
